// extracted by mini-css-extract-plugin
export default {"titleButton":"style_titleButton__DssHy","progressWrapper":"style_progressWrapper__SoUOd","titleWrapper":"style_titleWrapper__iZMg0","borderedTable":"style_borderedTable__4n5JC"};